declare const um_domain: string;


export const API_URL = `${um_domain}/wp-json/Casino`;
export const IFRAME_URL = `${um_domain}/Casino/lobby/loader.jsp`
export const GamesEndpointUrl = `${API_URL}/games/`
export const CategoriesEndpointUrl = `${API_URL}/categories/`
export const ProvidersEndpointUrl = `${API_URL}/providers/`;
export const BannersEndpointUrl = `${API_URL}/banners/`;

export const perPage = 18;
